<template>
  <div class="tenant">
    <TenantList v-show="!editionMode && hasTenants"></TenantList>
    <TenantForm></TenantForm>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TenantList from "@/components/records/tenant/TenantList"
import TenantForm from "@/components/records/tenant/TenantForm"

export default {
  name: "RecordsTenant",
  components: {
    TenantList,
    TenantForm
  },
  data: () => ({
    hasTenants: false
  }),
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord
    }),
    editionMode() {
      return !!this.$route.params.tenant_id
    }
  },
  async mounted() {
    const tenants = (await this.$api.recordsPeople.getTenants()).filter(tenant => {
      return !this.currentRecord.tenant_ids.includes(tenant.id)
    })
    this.hasTenants = tenants.length > 0
  }
}
</script>

<style scoped lang="scss">
$c: '.tenant';

#{$c} {
}
</style>